import { useEffect, useState } from 'react';

import {
  IonAvatar,
  IonButton,
  IonIcon,
  IonItem,
  IonLabel,
  IonNote,
  IonSpinner
} from '@ionic/react';
import { checkmarkCircleOutline } from 'ionicons/icons';

import styles from './TeammateRow.module.scss';

import { Service } from '../../services/service';
import { Teammate } from '../../types/services.types';

export interface TeammateRowProps {
  sendTeammateInvite: (email: string) => Promise<void>;
  service: Service;
  teammate: Teammate;
  token: string;
}

export const TeammateRow = ({
  token,
  service,
  teammate,
  sendTeammateInvite
}: TeammateRowProps) => {
  const [inviting, setInviting] = useState(false);
  const [avatarUrl, setAvatarUrl] = useState(teammate.photoURL);

  useEffect(() => {
    const fetchAvatar = async () => {
      const url = await service.getAvatar(
        token,
        teammate.email,
        teammate.photoURL,
        teammate.commitUrl ?? ''
      );
      setAvatarUrl(url);
    };

    fetchAvatar();
  }, [teammate]);

  const onInviteClicked = async () => {
    setInviting(true);
    try {
      await sendTeammateInvite(teammate.email);
    } catch (err) {
      console.error(err);
    }
    setInviting(false);
  };

  return (
    <IonItem>
      <div className={styles.teammate}>
        <div className={styles.teammateDetails}>
          <IonAvatar slot="start" className={styles.teammateAvatar}>
            <img src={avatarUrl} />
          </IonAvatar>
          <IonLabel>{teammate.name}</IonLabel>
          <IonNote>{teammate.email}</IonNote>
        </div>

        {!teammate.signedUp && (
          <div className={styles.teammateActions}>
            {inviting && (
              <IonButton
                className={styles.button}
                size="default"
                disabled={true}
              >
                Inviting <IonSpinner name="dots"></IonSpinner>
              </IonButton>
            )}
            {teammate.sent && (
              <div className={styles.sent}>
                Invite sent! <IonIcon icon={checkmarkCircleOutline}></IonIcon>
              </div>
            )}
            {!inviting && !teammate.sent && (
              <IonButton
                className={styles.button}
                size="default"
                onClick={onInviteClicked}
              >
                Invite
              </IonButton>
            )}
          </div>
        )}
      </div>
    </IonItem>
  );
};
